import React from 'react';

import { Field, Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

import Code from './Code';

type Props = {
  initValue: {};
  isDisabled: boolean;
  isRequired: boolean;
  onChange: (value?: {}) => void;
  title: string;
};

const defaultProps = {
  isRequired: true,
  title: 'Dropdown Source',
};

function StaticDropdownInputField({
  isDisabled,
  isRequired,
  onChange,
  title,
  initValue,
}: Props) {
  const onBlur = nextValue => {
    if (nextValue) {
      onChange(nextValue);
      // Replace ' with " if the new value is an array of an object.
      if (nextValue.includes(']') || nextValue.includes('}')) {
        onChange(JSON.parse(nextValue.replace(/'/g, '"')));
      }
    } else {
      if (!isRequired) {
        onChange(undefined);
      }
    }
  };

  const placeholder = '["Email", "Phone", "Address"]';

  return (
    <Field
      helpTextLineClamp={2}
      isDisabled={isDisabled}
      isRequired={isRequired}
      label={title}
      renderHelpText={() => (
        <Text tag="p">
          List the dropdown choices. Example: <code>{placeholder}</code>.{' '}
          <Link
            href={`${BASE_DOC_URL_VB}/build/add-fields#dropdown`}
            target="_blank"
          >
            Learn more
          </Link>
          .
        </Text>
      )}
      renderInput={() => (
        <Code initValue={initValue} onBlur={onBlur} placeholder={placeholder} />
      )}
    />
  );
}

StaticDropdownInputField.defaultProps = defaultProps;

export default StaticDropdownInputField;
